import { LoanDocState, TaskState } from 'gql/graphql';
import { Phases } from 'scenes/Private/Dashboard/LoanPhases.constanst';
import { getTaskIcon } from './processorPhaseStates';

/**
 * Procesa y filtra los items de borrower para una fase específica
 */
export const processBorrowerTaskItems = (
  phase: any,
  rulesTasksCards: any[],
  loanDocs: any[],
  loan: any
) => {
  if (!rulesTasksCards) return;

  const filteredRulesTaskCards = rulesTasksCards.filter(item => 
    item.phaseProgress === phase.key as Phases &&
    (!item.loanType || item.loanType?.includes(loan?.type)) &&
    (!item.loanPurposes || item.loanPurposes?.includes(loan?.purpose))
  );

  // Procesar cada task card para crear items
  rulesTasksCards.forEach((taskCard, index) => {
    if (
      taskCard.card &&
      taskCard.phaseProgress === phase.key as Phases &&
      (!taskCard.loanType || taskCard.loanType?.includes(loan.type)) &&
      (!taskCard.loanPurposes || taskCard.loanPurposes?.includes(loan?.purpose))
    ) {
      const buttonState = taskCard.progressButtons?.[taskCard.state];

      // Verificar si está bloqueado por loan doc
      const loanDocBlocked = loanDocs?.find(item =>
        item.state === LoanDocState.Blocking &&
        taskCard.state !== TaskState.Approved &&
        taskCard.state !== TaskState.Review &&
        taskCard.key.includes(item.key)
      );

      // Buscar documento relacionado
      const loanDocRef = loanDocs?.find(item =>
        taskCard.key.includes(item.key) &&
        (item.file?.url || (item.files && item.files?.length > 0)) &&
        !item.hidden
      );

      // Crear el task item de borrower
      phase.tasksItems.push({
        id: index,
        key: taskCard.key,
        modalKey: taskCard.modalKey,
        icon: getTaskIcon(taskCard.state, phase.state),
        text: taskCard.name,
        titleButton: buttonState ? buttonState.label : 'View',
        state: loanDocBlocked ? 'BLOCKED' : taskCard.state,
        loanDoc: loanDocRef
      });
    }
  });

  return filteredRulesTaskCards;
};